import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  DATA_E2E_KEY,
  IInjectedDrawerProps,
  IRelatedEntitiesDrawerProps,
  SINGLE_KEY,
} from "@ryde/shared";

import { LayoutRightHeaderTitleStyled } from "../../../right";
import {
  DrawerCloseIconButton,
  DrawerContentStyled,
  MenuBaseDrawer,
  MenuDrawerHeaderStyled,
} from "../drawer";
import {
  RELATED_ENTITIES_DRAWER_WIDTH_PX,
  RelatedEntitiesDrawerActions,
  RelatedEntitiesIdMetaStyled,
  RelatedEntitiesTable,
  RelatedEntitiesUnitStyled,
} from "./parts";
import { useRelatedEntitiesDrawer } from "./use-related-entities-drawer";

export const RelatedEntitiesDrawer: FC<
  IRelatedEntitiesDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, entity, entityId }) => {
  const { t } = useTranslation();
  const { rows, isLoading, refetch, downloadExcel } = useRelatedEntitiesDrawer({
    entity,
    entityId,
  });

  const unitTitle = t(`${entity}.${SINGLE_KEY}`);
  const titlePrefix = t("general.RELATED_ENTITIES_OF", {
    defaultValue: "Related entities of",
  })
    .replace(/\s*#\{\{id\}\}/g, "")
    .replace(/\s*\{\{entity\}\}/g, "")
    .replace(/\s+#\s*$/, "")
    .trimEnd();

  return (
    <MenuBaseDrawer
      onCloseDrawer={onCloseDrawer}
      customWidth={`${RELATED_ENTITIES_DRAWER_WIDTH_PX}px`}
      drawerNumber={drawerNumber}
    >
      <MenuDrawerHeaderStyled>
        <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
          {titlePrefix}{" "}
          <RelatedEntitiesUnitStyled>{unitTitle}</RelatedEntitiesUnitStyled>{" "}
          <RelatedEntitiesIdMetaStyled>
            <span className="id-meta">(id: </span>
            <span className="id-value">{entityId}</span>
            <span className="id-meta">)</span>
          </RelatedEntitiesIdMetaStyled>
        </LayoutRightHeaderTitleStyled>
        <RelatedEntitiesDrawerActions
          onRefresh={refetch}
          onDownload={downloadExcel}
          isLoading={isLoading}
        />
        <DrawerCloseIconButton onCloseDrawer={onCloseDrawer} />
      </MenuDrawerHeaderStyled>

      <DrawerContentStyled
        className="related-entities-drawer-content"
        {...{ [DATA_E2E_KEY]: "related-entities-drawer-content" }}
      >
        <RelatedEntitiesTable
          rows={rows}
          isLoading={isLoading}
          onEntityClick={refetch}
        />
      </DrawerContentStyled>
    </MenuBaseDrawer>
  );
};
